<template>
    <modal id="category-modal"
           v-model="showModal"
           :title="generateModalTitle('category')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader"
    >
        <form method="post"
              @submit.prevent="submitData"
              ref="form"
        >
            <app-form-group
                    :label="$t('name')"
                    v-model="formData.name"
                    :placeholder="$placeholder('category', 'name')"
                    :error-message="$errorMessage(errors, 'name')"
            />
            <app-form-group-selectable
                    type="select"
                    :label="$t('parent_category')"
                    list-value-field="name"
                    v-model="formData.category_id"
                    :chooseLabel="$t('category')"
                    :error-message="$errorMessage(errors, 'category_id')"
                    :fetch-url="apiUrl.SELECTABLE_MAIN_CATEGORIES"
                    v-if="isCategoryEnabled"
            />

            <app-form-group-selectable
                    type="search-select"
                    :label="$t('icon')"
                    v-model="formData.icon"
                    list-value-field="value"
                    :chooseLabel="$t('icon')"
                    :error-message="$errorMessage(errors, 'icon')"
                    :fetch-url="apiUrl.SELECTABLE_ICONS"
            />

            <app-form-group
                type="single-checkbox"
                label=""
                v-model="formData.is_in_home_page"
                :error-message="$errorMessage(errors, 'is_in_home_page')"
                :list-value-field="$t('is_in_home_page')"
            />

            <div class="form-group">
                <label>
                    {{ $t('logo') }}
                    <app-input
                            :label="$t('choose_logo')"
                            type="custom-file-upload"
                            :generate-file-url="false"
                            v-model="formData.logo"
                            :error-message="$errorMessage(errors, 'image')"
                    />
                </label>
            </div>
        </form>
    </modal>
</template>

<script>
    import ModalMixin from "../../../Mixins/ModalMixin";
    import FormHelperMixin from "../../../Mixins/FormHelperMixin";
    import {formDataAssigner} from "../../../Helpers/Helpers";

    export default {
        mixins: [ModalMixin, FormHelperMixin],
        name: "CategoryCreateEdit",
        data() {
            return {
                formData: {
                    icon: ''
                }
            }
        },
        methods: {
            submitData() {
                this.fieldStatus.isSubmit = true;
                this.loading = true;
                this.message = '';
                this.errors = {};
                this.formData.is_in_home_page = Boolean(this.formData.is_in_home_page) ? 1 : 0;
                if (!this.formData.category_id) {
                    delete this.formData.category_id;
                }
                const formData = formDataAssigner(new FormData, this.formData);
                if (this.formData.logo) {
                    formData.append('image', this.formData.logo);
                }
                if (this.selectedUrl) {
                    formData.append('_method', 'PUT')
                }
                const url = this.selectedUrl ? this.selectedUrl : this.apiUrl.CATEGORIES;
                this.submitFromFixin('post', url, formData);
            },
            afterSuccess({data}) {
                this.formData = {};
                $('#category-modal').modal('hide');
                this.$emit('input', false);
                this.toastAndReload(data.message, 'category-table');
            },
            afterSuccessFromGetEditData(response) {
                this.preloader = false;
                this.formData = response.data;
                this.formData.is_in_home_page = Boolean(this.formData.is_in_home_page);
            },
        },
        computed: {
            isCategoryEnabled() {
                if (!this.selectedUrl) {
                    return true;
                }

                return !Boolean(this.selectedUrl &&
                    this.$optional(this.formData, 'sub_categories', 'length'));
            }
        }
    }
</script>

<style scoped>

</style>